import { skipTracingStore } from "../store";
import { CreateSkipTraceOrderStep } from "react-migration/domains/sites/typings/SkipTraceOrderStep";

export const updateCurrentStep = (step: CreateSkipTraceOrderStep) => {
  skipTracingStore.currentStep = step;
};
